import React from "react";

const TermsPage = () => {
  return (
    <div className="max-w-6xl mx-auto py-16 px-4 terms">
      <h1 className="text-5xl font-light text-gray-800 mb-2">
        Términos y condiciones El Señorón
      </h1>
      <p className="font-black mb-8 text-gray-800">
        Ultima actualización 7 de Diciembre 2020.
      </p>
      <div className="max-w-4xl font-light">
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Estimado Usuario, bienvenido a “El Señorón”, le agradecemos haber
          ingresado a nuestra página web transaccional. La presente página es
          desarrollada y operada por El Señoron Comercial, S.A. de C.V., misma
          que tiene domicilio en [Melocoton 500, Colonia Fernando Amilpa,
          Escobedo, Nuevo León México] (de aquí en delante “El señoron
          comercial” o “El señoron”, a ser utilizada indistintamente).
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Hacemos de su conocimiento que al ingresar a El señoron y realizar
          alguna transacción dentro de la plataforma, se entiende que usted ha
          leído los siguientes TÉRMINOS Y CONDICIONES que rigen el uso de la
          misma, y por ende, está enterado y los acepta en su totalidad. A la
          luz de lo anterior, le solicitamos de la manera más atenta revise este
          documento detenidamente.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los presentes TÉRMINOS Y CONDICIONES, están diseñados para brindar a
          todos los usuarios que hacen uso de la página web El señoron, un
          ambiente seguro, así como una experiencia favorable, motivo por el
          cual los términos aquí referidos, delimitan las áreas de
          responsabilidad y derechos, tanto de EL SEÑORON COMERCIAL, como de sus
          usuarios.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Si el Usuario no acepta los presentes Términos y Condiciones, deberá
          abstenerse de utilizar El señoron. La sola utilización de esta página
          le otorga la condición de Usuario, e implica la aceptación plena e
          incondicional, de todas y cada una de las condiciones que se
          establecen en estos Términos y Condiciones de uso, así como en las
          demás políticas publicadas por EL SEÑORON COMERCIAL, al momento mismo
          en que el Usuario accede a la página web. Cualquier modificación y/o
          actualización a los Términos y Condiciones será realizada cuando EL
          SEÑORON COMERCIAL lo considere apropiado, siendo exclusiva
          responsabilidad del Usuario revisar las respectivas modificaciones.
        </p>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          MODIFICACIONES Y/O ACTUALIZACIONES
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL podrá realizar libremente y en cualquier momento,
          modificaciones formales, procedimentales o sustanciales a los TÉRMINOS
          Y CONDCIONES de uso de El señoron, sin necesidad de dar aviso al
          Usuario, realizar correcciones, adiciones, mejoras o modificaciones al
          contenido, presentación, información, bases de datos y demás elementos
          de El señoron sin que ello de lugar ni derecho a ninguna reclamación o
          indemnización, ni que lo mismo implique reconocimiento de
          responsabilidad alguna a favor del Usuario. Cada ocasión que el
          Usuario acceda a El señoron se considerará como aceptación absoluta de
          las modificaciones a los Términos y Condiciones. Estos TERMINOS Y
          CONDICIONES tuvieron su última actualización el 07 de diciembre del
          año 2020. Por favor revise periódicamente, para estar al corriente con
          cualquier cambio.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          TÉRMINOS Y CONDICIONES SUPLEMENTARIOS
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL podrá aplicar términos y condiciones
          suplementarias a ciertos o determinados servicios, tales como pero sin
          limitarse a: eventos especiales o promociones, por señalar algunos.
          Estos términos y condiciones suplementarios se le comunicarán al
          usuario para el producto o servicio al que le apliquen.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los términos y condiciones suplementarios serán considerados como
          parte de los TÉRMINOS Y CONDICIONES, y en caso de conflicto,
          prevalecerán los primeros sobre los segundos.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          AVISO DE PRIVACIDAD
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL se preocupa por cuidar la seguridad de los datos
          personales que proporciona el Usuario a través de El señoron, los
          cuales son utilizados para diversas actividades, las cuales incluyen
          pero no se limitan a: procesar las compras, hacer la entrega del
          pedido en su domicilio, brindar un mejor servicio, mejorar su
          experiencia de compra, así como para enviar publicidad y promociones.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Para mayor información sobre el tratamiento de sus datos personales,
          EL SEÑORON COMERCIAL de conformidad con las disposiciones de la Ley
          Federal de Protección de Datos Personales en Posesión de Particulares,
          y las disposiciones que emanan de ella o se relacionan con la misma,
          pone a su disposición su Aviso de Privacidad Integral en su página web
          www.elsenoron.com
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Le solicitamos de la manera más atenta, se dé la oportunidad de leer y
          revisar nuestro Aviso de Privacidad, para que conozca nuestras
          prácticas.
        </p>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          REGLAS DE USO DE EL SEÑORON
        </p>
        <ul className="text-lg list-disc px-4">
          <li className="list-disc mb-4 text-gray-700 leading-7">
            USUARIOS: El contenido y servicios que ofrece la aplicación El
            señoron, está reservado y dirigido únicamente a un público mayor de
            18 (dieciocho) años. Queda bajo responsabilidad exclusiva de los
            padres o tutores, supervisar la conducta de los menores de edad que
            ingresen o hagan uso de la aplicación.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            LICENCIA: Sujeto a los TÉRMINOS y CONDICIONES de El señoron, EL
            SEÑORON COMERCIAL les otorga a los Usuarios una autorización
            limitada, no exclusiva, revocable e intransferible para acceder y
            hacer uso de la aplicación El señoron, conforme al diseño que le fue
            otorgado por EL SEÑORON COMERCIAL, y solo para su uso personal, y no
            comercial. EL SEÑORON COMERCIAL, sus licenciantes y proveedores, se
            reservan cualquier derecho que no haya sido otorgado conforme a los
            presentes TÉRMINOS y CONDICIONES.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            ACCESO: El Usuario podrá acceder a EL SEÑORON y hacer uso de las
            funciones contenidas dentro de la página web, iniciando sesión
            creando una cuenta con su correo electrónico. El usuario podrá
            completar su perfil de El señoron con los siguientes datos: nombre,
            género, fecha de nacimiento, domicilio y número de teléfono móvil;
            adicionalmente podrá registrar tarjetas de débito o crédito, con los
            siguientes datos: número de tarjeta, nombre de tarjeta habiente,
            tipo de tarjeta, fecha de vencimiento de tarjeta y código de
            seguridad (CCV). Los datos bancarios y financieros serán operados
            por Stripe bajos sus propios términos y condiciones y avisos de
            privacidad estipulados en https://stripe.com Al momento de
            registrarse como Usuario de la página El señoron, usted certifica
            que los datos ingresados son correctos y legítimos. Para efectos de
            validación y seguridad de la operación, EL SEÑORON COMERCIAL podrá
            solicitar en cualquier momento los documentos que avalen la
            autenticidad de la identidad del Usuario. En caso de que la
            información suministrada por el Usuario no sea veraz, completa o
            segura, EL SEÑORON COMERCIAL tendrá la facultad para no cancelar o
            restringir la cuenta del Usuario en cualquier momento.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            CUENTA DE USUARIO Y CONTRASEÑA: El uso de su usuario y contraseña es
            su responsabilidad exclusiva, por lo que le recomendamos que
            mantenga confidencialidad al respecto y no revele dicha información.
            El uso de la cuenta de usuario es personal e intransferible, por lo
            que el Usuario no se encuentra facultado para ceder los datos de
            validación para acceder a la aplicación. En caso de olvido de los
            datos de validación o usurpación de éstos, es obligación del Usuario
            informarlo a EL SEÑORON COMERCIAL y modificar su contraseña dentro
            de la página a través de la opción “Recuperar contraseña”, misma que
            se encuentra dentro de la página. EL SEÑORON COMERCIAL no es
            responsable de la utilización de su usuario y/o contraseña, por lo
            que se deslinda de cualquier actividad realizada a través de El
            señoron de manera irregular.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            USO: El uso de El señoron es única y exclusivamente para que el
            Usuario pueda consultar y, en su caso, comprar los productos y
            artículos que se comercializan a través de la misma; es por ello que
            cualquier otro uso no relacionado de manera directa con los
            anteriores, se considerará como una violación a estos TÉRMINOS Y
            CONDICIONES. EL SEÑORON COMERCIAL, o cualquier tercero al que este
            designe, serán responsables de la administración de las cuentas de
            los usuarios de El señoron; EL SEÑORON COMERCIAL estará facultado
            para cancelar o restringir las cuentas si detectan violación a los
            TÉRMINOS Y CONDICIONES. Entre las conductas indebidas se incluyen de
            manera enunciativa y no limitativa: (i) Revender los productos; (ii)
            Darle a la aplicación El señoron cualquier otro uso comercial
            distinto al previsto en estos TERMINOS Y CONDICIONES; (iii) Utilizar
            mecanismos de cualquier naturaleza para de manera directa o
            indirecta, extraer cualquier información contenida en la aplicación;
            (iv) Recopilar y utilizar las fotografías, descripciones, marcas o
            logos de los productos, así como cualquier banner promocional que se
            coloque dentro de la aplicación; y (v) intentar o realizar
            actividades fraudulentas, por señalar algunas. Adicional a dar de
            baja la cuenta del Usuario, EL SEÑORON COMERCIAL podrá tomar las
            acciones legales que considere adecuadas para garantizar el correcto
            funcionamiento de dicha aplicación. En caso de tener cualquier duda
            respecto al uso de esta aplicación y de sus TÉRMINOS Y CONDICIONES,
            ponemos a su disposición nuestro número de Atención a Clientes [(81)
            14952291] y el correo electrónico
            [senoron.atencionclientes@gmail.com].
          </li>
        </ul>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          OBLIGACIONES DEL USUARIO DE EL SEÑORON
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario de El señoron se obliga a:
        </p>
        <ul className="text-lg list-disc px-4">
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Utilizar El señoron de conformidad con los presentes TÉRMINOS Y
            CONDICIONES.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Aceptar los precios y sus respectivos impuestos, según sean
            mostrados dentro de El señoron.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Proporcionar información veraz, precisa y legítima al momento que le
            sea solicitada.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Ser responsable de las transacciones llevadas a cabo a través de El
            señoron, incluyendo el costo de los productos y artículos, cargos de
            servicio a domicilio e impuestos derivados de la compra, según
            aplique.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Abstenerse de proporcionar información de la cual usted no sea
            titular.{" "}
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Al utilizar el método de pago con tarjeta de crédito y/o débito,
            debe cumplir y acreditar todos los procesos de validación previstos
            por el procesador de pagos (según se define más adelante).
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Abstenerse de copiar, reenviar, reproducir, reutilizar, vender,
            transmitir, distribuir, descargar, otorgar licencia, modificar,
            publicar o usar de alguna otra manera el contenido de El señoron
            para fines públicos o comerciales.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Abstenerse de transferir a terceros su nombre de usuario y
            contraseña.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Abstenerse de acceder y/o usar la página web para realizar actos
            contrarios a la moral, al orden público, a las buenas costumbres o
            actos o hechos ilícitos en contra de EL SEÑORON COMERCIAL, sus
            proveedores o terceros.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Pagar oportunamente a EL SEÑORON COMERCIAL la contraprestación por
            los productos adquiridos.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Proporcionar métodos válidos y veraces para realizar sus pagos.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            Sacar en paz a EL SEÑORON COMERCIAL y a cualquiera de sus empresas
            filiales o subsidiarias, en caso de cualquier controversia,
            reclamación o juicio derivado del mal uso dado a la página El
            señoron a través de la cuenta de usuario del Usuario.
          </li>
        </ul>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          COMPRAS DE PRODUCTOS A TRAVÉS DE EL SEÑORON
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Términos generales.{" "}
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los productos y artículos adquiridos a través de El señoron serán
          regidos por los presentes TÉRMINOS Y CONDICIONES y la legislación
          mexicana aplicable.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario acepta los precios según se presenten dentro de la página
          al momento de generar la compra, y asimismo manifiesta su conformidad
          en que estos puedan ser variados a discreción de EL SEÑORON COMERCIAL
          sin necesidad de aviso o notificación previa.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El precio de todos los productos es anunciado en Pesos Mexicanos,
          moneda del curso legal de los Estados Unidos Mexicanos, por lo cual es
          esta moneda la que regirá todas las operaciones realizadas a través de
          El señoron.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL publica los precios incluyendo los impuestos
          aplicables, por lo que los precios que usted visualice en El señoron
          son precios finales, excepto por los cargos de envío, que en su caso
          apliquen.{" "}
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario acepta que puede haber promociones y precios que varíen
          dentro de las tiendas físicas y las que aparezcan en la página.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Cuando el Usuario acepta el contenido de su carrito de artículos
          dentro de la aplicación se compromete a realizar el pago de todos los
          que se incluyan en este, y no podrá exigir cambios, devoluciones y/o
          modificaciones a este, salvo que se cumpla con lo señalado en el
          apartado de Modificaciones de Productos y Artículos.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Productos y artículos
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En algunos de los productos aparecen fotografías ilustrativas de los
          productos con la finalidad de mostrar al Usuario una imagen más clara
          sobre los mismos, sin embargo, el color o colores que aparecen en las
          mismas, así como la visualización de las dimensiones pueden variar
          dependiendo de la perspectiva en que fue tomada la fotografía o la
          calidad del equipo en donde se ingresa a El señoron. Le pedimos leer
          la información, descripción y características de su compra para que
          conozca exactamente lo que está comprando.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El precio que aparece en cada uno de los productos y artículos en El
          señoron es publicado de manera clara y precisa, y puede ser
          identificado con el producto o artículo del que se trate, así como las
          promociones y descuentos que aplican. Estos precios serán únicamente
          válidos en El señoron, para las transacciones realizadas a través del
          mismo. EL SEÑORON COMERCIAL no se obliga a respetar estos precios,
          promociones y descuentos a través de otra forma de transacción
          diferente a El señoron, o en los establecimientos físicos EL SEÑORON
          COMERCIAL.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Por la naturaleza de ciertos productos, su precio varía constantemente
          e incluso pudiera ser distinto de un día a otro. En virtud de lo
          anterior, el precio que regirá la compraventa a través de El señoron
          será del día en que se lleve a cabo la transacción electrónica.{" "}
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL trabaja para que la información de los productos
          anunciados en El señoron sea precisa, adecuada y corresponda a los
          mismos. Sin embargo, la misma podría contener errores, inexactitudes o
          no encontrarse actualizada; por lo anterior, EL SEÑORON COMERCIAL
          podrá en cualquier momento modificar el contenido de El señoron sin
          necesidad de dar aviso alguno.{" "}
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Modificación y/o Cancelación de la Entrega de Productos y Artículos
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          La modificación de los artículos y productos contenidos dentro del
          pedido ya emitido y aceptado por el Usuario, únicamente podrán ser
          modificados siempre que el Usuario llame a los teléfonos del Call
          Center de El señoron, previo a que el estatus de su orden indique “En
          camino”.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Un pedido podrá ser cancelado únicamente a través de la página durante
          el tiempo que el estatus de la orden lo permita, desde la pantalla de
          “Seguimiento de Pedido”. Para cancelar un pedido por causas de fuerza
          mayor, después del tiempo estipulado anteriormente, el Usuario deberá
          llamar al (81) 14952291 y la situación será evaluada para su
          cancelación, aceptando que se le cobrará el costo por envío como
          penalización.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En caso de que el Usuario no cumpla con lo señalado en el párrafo
          anterior, no tendrá la posibilidad de exigir la modificación y/o
          cancelación de su pedido y será responsable de efectuar el pago de los
          mismos, conforme a las disposiciones aquí previstas.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En este tenor, en caso de pago con tarjeta bancaria, el Usuario
          renuncia expresamente a su derecho de generar cualquier tipo de contra
          cargo directamente con el banco emisor de la tarjeta que corresponda,
          comprometiéndose a realizar el pago íntegro del pedido. Lo mismo
          aplicará cuando el método de pago seleccionado sea efectivo, puesto
          que el Usuario se compromete a realizar el pago íntegro del pedido al
          repartidor, una vez que este llegue a su domicilio. Si el Usuario no
          cumple con sus obligaciones aquí previstas, El señoron tendrá la
          facultad discrecional de suspender y/o cancelar la cuenta del Usuario,
          reservándose cualquier derecho de cobro adicional que la legislación
          de la materia le otorgue.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Formas de pago de los productos y artículos
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Una vez que el Usuario finalice la selección de los productos que
          adquirirá mediante El señoron, le aparecerá el costo total de su
          compra, incluyendo el costo de envío, en caso de que aplique.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">Formas de pago:</p>
        <ol>
          <li>Tarjeta de crédito o de débito en línea.</li>
          <li>Efectivo</li>
        </ol>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Cuando el Usuario seleccione forma de Pago con Tarjeta de Crédito o
          Débito en línea:
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL procesará los pagos de tarjetas de crédito y
          débito por vía de Stripe Payments Mexico, S. de R.L. de C.V.
          (“Stripe”, “Stripe Mexico”). En virtud de lo anterior, EL SEÑORON
          COMERCIAL no es responsable de la referida información, así como del
          procesamiento de los pagos. Para mayor información de los Términos y
          Condiciones de Stripe favor de consultar https://stripe.com/mx/ssa
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Para pago con tarjeta de crédito o débito, el Usuario deberá ingresar
          desde la página El señoron con la finalidad de transferir la
          información de sus tarjetas al portal de Stripe para registrarse y
          obtener su ID de Usuario con su tarjeta de crédito o débito, mediante
          el cual podrá adquirir productos dentro de El señoron.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario deberá revisar los términos y condiciones del portal
          Stripe, en caso de seleccionar la opción de pago de tarjeta de débito
          o crédito e ingresar todos sus datos, se comprenderá que revisó y
          aceptó todos los términos y condiciones de Stripe, liberando entonces
          a EL SEÑORON COMERCIAL de cualquier responsabilidad relacionada con el
          método de pago electrónico y reembolsos, en su caso.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El señoron tiene el derecho y la facultad discrecional de imponer y
          definir todas las medidas que estime necesarias y convenientes para
          salvaguardar la integridad de la aplicación El señoron; por lo que en
          caso de detectar acciones o eventualidades sospechosas o que considere
          son de carácter ilícito o ilegal, tendrá la facultad de realizar, pero
          sin limitarse, a las siguientes acciones: bloquear, suspender o
          cancelar, la cuenta del Usuario.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Cuando el Usuario seleccione forma de Pago en Efectivo:
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario se compromete a realizar el pago en efectivo con billetes
          auténticos y validados por BANXICO; en caso de que EL SEÑORON
          COMERCIAL detecté que el pago fue realizado con un billete
          falsificado, el Usuario se compromete a sustituir y reponer el
          billete. Lo aquí previsto no implica una renuncia de EL SEÑORON
          COMERCIAL a ejercer los medios de defensa legal que tenga disponibles
          para requerir el pago.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario reconoce y acepta que los repartidores no cuentan con
          cambio mayor a $500.00 (Quinientos Pesos 00/100 Moneda Nacional), por
          lo que no podrá efectuar el pago con una cantidad que implique que el
          repartidor otorgue como cambio un monto superior al aquí establecido.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Entrega a domicilio de pedidos{" "}
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          La entrega a domicilio de pedidos únicamente podrá realizarse dentro
          de las zonas de la Ciudad de Monterrey, N.L., definidas de manera
          discrecional por El señoron. Dichas zonas, podrán ser variadas de
          tiempo en tiempo, y según lo requiera El señoron, sin tener la
          obligación de notificarlo o avisarlo al Usuario previamente.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Previo a la aceptación del pedido, se verificará si el Usuario se
          encuentra dentro de la zona de cobertura habilitada en ese momento
          para que se le pueda hacer la entrega en su domicilio de su pedido.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Una vez finalizada la selección del producto y confirmación del
          pedido, se realizará el mejor esfuerzo posible, sin tener ninguna
          obligación por parte de El señoron y la empresa logística asociada,
          por realizar la entrega a domicilio en un plazo promedio de 45
          (cuarenta y cinco) minutos, según la disponibilidad que se indique al
          momento de confirmar el pedido. El Usuario tendrá la facultad de
          realizar el seguimiento de su pedido a través de la página, por medio
          de los status visibles en la sección de “Pedidos”.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En caso de que la entrega a domicilio no pueda concretarse
          satisfactoriamente por las siguientes condiciones: climáticas, de
          tránsito, manifestaciones, obras y/o adecuaciones viales, o
          eventualidades provocadas por caso fortuito o fuerza mayor, así como
          cualquier otra relacionada, esto será notificado con una llamada al
          teléfono previamente registrado oportunamente.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Una vez que el repartidor llegue al domicilio del Usuario éste llamará
          a su puerta para realizar la entrega de los productos solicitados, en
          caso de que el Usuario no atienda al llamado, el repartidor lo
          esperará en un plazo no mayor de 5 (cinco) minutos con la finalidad de
          hacer la entrega. Transcurrido este plazo, el Call Center de EL
          SEÑORON COMERCIAL realizará el intento de localizar al Usuario por
          medio de una llamada telefónica e informarle de la llegada del
          repartidor. Si no hay respuesta a esta llamada, el repartidor podrá
          retirarse sin que el Usuario pueda exigir reembolso del precio de los
          productos.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Para la entrega de artículos prohibidos para menores de edad, tales
          como (pero sin limitarse a) bebidas alcohólicas, los repartidores de
          El señoron al llegar al domicilio señalado para la entrega,
          solicitaran la presentación de una identificación oficial (únicamente
          credencial electoral emitida por el Instituto Nacional Electoral,
          licencia o pasaporte oficial vigentes) que acredite la mayoría de edad
          del Usuario que recibe el pedido.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los repartidores tendrán la facultad de inspeccionar los documentos
          oficiales presentados para asegurarse: (i) que los datos del Usuario
          coincidan con los datos de la identificación proporcionada; y (ii) que
          sea el Usuario quien reciba el pedido; en caso de que se encuentre
          alguna discrepancia con los anteriores puntos, el repartidor tendrá la
          facultad de negar la entrega de los productos, sin que esto implique
          responsabilidad para éste o para EL SEÑORON COMERCIAL, y se
          considerará como una Devolución de conformidad con lo aquí previsto.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">Ticket</p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El ticket de compra de los artículos comprados a través de El señoron,
          estará disponible para consulta al momento de concluir con la compra y
          haber realizado el pago efectivo de los artículos y productos.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Horarios de servicio a domicilio
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Nuestro horario de entrega a domicilio es el siguiente:
        </p>
        <ul className="text-lg list-disc px-4">
          <li className="list-disc mb-4 text-gray-700 leading-7">
            De lunes domingo de 3:00PM a 11:00PM
          </li>
        </ul>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Restricción de Horario de Operación
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario no podrá adquirir y El señoron no podrá entregar a
          domicilio productos que tengan restricciones legales para su
          comercialización, regulaciones específicas o restricciones de horarios
          de venta, como por ejemplo, enunciando sin limitar, la prohibición de
          venta de bebidas alcohólicas los domingos después de las 6:00 PM (o en
          su caso el horario que le sea aplicable de conformidad con la
          legislación vigente del estado donde se realice el pedido).
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Devolución
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario al momento de la entrega deberá revisar los productos
          solicitados y en caso de detectar algún defecto visible podrá rechazar
          la recepción de uno o más productos, así mismo, el Usuario podrá
          elegir entre recibir un reemplazo de producto o reembolso de su
          dinero.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En caso de que el Usuario realice el pago de su pedido a través de una
          tarjeta de crédito o débito, si aplica la devolución, El señoron
          notificará al banco emisor para efectuar la devolución del dinero,
          misma que será conforme a los términos y condiciones particulares y
          específicas de cada banco.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Una vez entregados los productos en el domicilio, el Usuario tendrá 30
          minutos después de la entrega para notificar al Call Center El señoron
          de cualquier error, defecto o discrepancia en su orden realizada para
          poder efectuar devoluciones.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Garantía de los productos
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON no otorga ninguna especie de garantía sobre el contenido de
          los productos, para quejas respecto a la calidad de los mismos, el
          Usuario deberá comunicarse directamente con el proveedor responsable
          del producto de que se trate.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Si al momento de la entrega el Usuario recibe los productos del pedido
          sin manifestar cualquier inconformidad, se tendrán por aceptados y el
          Usuario perderá cualquier derecho de reclamación a EL SEÑORON
          COMERCIAL pasados los 30 minutos de haber cerrado el pedido.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Disposiciones especiales
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          La disponibilidad de los productos corresponderá a la existencia
          física de los mismos en los establecimientos participantes cercanos a
          la ubicación desde la cual el Usuario realice el pedido, en virtud de
          lo anterior, el Usuario acepta que en caso de no existir físicamente
          el producto solicitado, EL SEÑORON COMERCIAL se comunicará con el
          Usuario por medio de una llamada telefónica al número registrado en su
          cuenta, para hacerlo de su conocimiento y este podrá, a su elección:
          (i) solicitar que se descuente el precio del artículo no disponible;
          (ii) solicitar la cancelación total del pedido de que se trate; (iii)
          solicitar a EL SEÑORON COMERCIAL la sustitución del producto en
          desabasto por uno similar de acuerdo a las indicaciones del Usuario.
        </p>
        <ol>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            En caso de solicitar el descuento del precio del artículo no
            disponible, EL SEÑORON COMERCIAL emitirá un nuevo ticket que ampare
            los productos que serán entregados al Usuario, eliminando el
            producto no disponible, actualizando el monto a pagar por parte del
            Usuario, el cual se cobrará conforme a la forma de pago seleccionada
            por éste último.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            En caso de solicitar la cancelación total del pedido, EL SEÑORON
            COMERCIAL procederá a efectuar la cancelación y no entregará los
            productos solicitados.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            En caso de solicitar la sustitución del producto, EL SEÑORON
            COMERCIAL emitirá un nuevo ticket que ampare los productos que serán
            entregados al Usuario, actualizando éstos, así como el monto a pagar
            por parte del Usuario, el cual se cobrará conforme a la forma de
            pago seleccionada por éste último.
          </li>
        </ol>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En todos los casos en que sea procedente reembolso, cuando el medio de
          pago sea tarjeta de crédito o débito en línea, EL SEÑORON COMERCIAL
          dará aviso a Stripe, quien a su vez informará a la Institución
          Financiera correspondiente para que realice el reembolso que proceda.
          Este procedimiento se encuentra bajo la responsabilidad y tratamiento
          del Banco emisor de la tarjeta del Usuario, por lo que los tiempos
          pueden variar según cada Institución.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En el caso de que se realice el pedido de compra sobre productos que
          tengan restricciones legales para su comercialización o alguna
          regulación específica, se estará sujeto al cumplimiento de las mismas,
          en virtud de lo cual EL SEÑORON COMERCIAL se reserva el derecho a
          negar la entrega de dichos productos en el domicilio del que se trate,
          si este es el caso, dicha cantidad será descontada de su cuenta. En
          caso de pago mediante tarjeta de crédito o débito en línea, EL SEÑORON
          COMERCIAL dará aviso a Stripe, quien a su vez informará a la
          Institución Financiera correspondiente para que realice el reembolso
          que proceda. Este procedimiento se encuentra bajo la responsabilidad y
          tratamiento del Banco emisor de la tarjeta del Usuario, por lo que los
          tiempos pueden variar según cada Institución.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7 underline">
          Códigos promocionales y descuentos.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL podrá a su sola discreción, crear códigos
          promocionales que podrán ser canjeados por beneficios dentro de la
          página El señoron, con sujeción a cualquier condición adicional que EL
          SEÑORON COMERCIAL establezca sobre la base de cada código promocional
          (en lo sucesivo “Códigos promocionales”). El Usuario reconoce y acepta
          que los Códigos promocionales deben ser utilizados para la audiencia y
          el propósito deseado, y de manera lícita, por lo que está prohibida su
          venta y/o transferencia por cualquier medio. El Usuario reconoce y
          acepta que los Códigos Promocionales podrán ser invalidados y/o
          cancelados por EL SEÑORON COMERCIAL en cualquier momento y por
          cualquier motivo, sin responsabilidad alguna para éste.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los Códigos Promocionales podrán utilizarse únicamente dentro de la
          páginade El señoron y conforme a las condiciones específicas que EL
          SEÑORON COMERCIAL establezca para cada uno de ellos; además no son
          válidos como efectivo y podrán caducar antes de que el Usuario los
          utilice.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL se reserva el derecho de retener o reducir los
          beneficios para el Usuario obtenidos mediante los Códigos
          Promocionales, en el caso de que EL SEÑORON COMERCIAL determine o crea
          que el uso o canje de dichos códigos se efectuó de modo fraudulento,
          ilegal o infringiendo las condiciones del Código promocional o las
          presentes Condiciones.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Asimismo, EL SEÑORON COMERCIAL podrá a su sola discreción, otorgar
          descuentos en los productos que comercializa mediante El señoron,
          siempre que el Usuario cumpla con los requisitos que al efecto le
          indique EL SEÑORON COMERCIAL para cada campaña promocional que se
          trate. Todo lo anteriormente señalado para los Códigos Promocionales
          regirá a los descuentos que, en su caso otorgue EL SEÑORON COMERCIAL,
          en lo que sea aplicable.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Está terminantemente prohibido que un Usuario cree diferentes cuentas
          o efectúe cualquier conducta con la finalidad de beneficiarse
          indebidamente de descuentos y Códigos Promocionales lo cual se
          considera un uso abusivo de las mismas.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          DERECHOS DE AUTOR Y PROPIEDAD INDUSTRIAL
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL, El señoron, sus logotipos y los de los productos
          que se comercializan mediante dicha página, así como todo el material
          de la misma son marcas, nombres de dominio, nombres comerciales,
          avisos comerciales, entre otros, propiedad de EL SEÑORON COMERCIAL y/o
          sus proveedores y están protegidos por los tratados internacionales y
          las leyes aplicables en materia de propiedad intelectual y derechos de
          autor. Los derechos de autor sobre el contenido, organización,
          recopilación, compilación, información, logotipos, fotografías,
          imágenes, programas, aplicaciones, software, código fuente, desarrollo
          y en general cualquier información contenida, publicada y necesaria
          para el funcionamiento de El señoron, se encuentran debidamente
          protegidos a favor de EL SEÑORON COMERCIAL y/o sus proveedores, en su
          caso, de conformidad con la legislación aplicable en materia de
          propiedad intelectual e industrial. Se prohíbe expresamente al Usuario
          modificar, alterar o suprimir, ya sea en forma total o parcial, los
          avisos, marcas, nombres comerciales, señas, anuncios, logotipos o en
          general cualquier indicación que se refiera a la propiedad de la
          información contenida en El señoron.
        </p>{" "}
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          NEGACIÓN DE GARANTÍAS
        </p>{" "}
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL se libera de cualquier responsabilidad y
          condiciones, tanto expresas como implícitas, en relación con los
          servicios e información contenida o disponible en o a través de esta
          aplicación, incluyendo sin limitación alguna:
        </p>
        <ul className="text-lg list-disc px-4">
          <li className="list-disc mb-4 text-gray-700 leading-7">
            La disponibilidad del uso de El señoron.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            La ausencia de errores, desactivadores o cualquier otro material
            contaminante o con funciones destructivas en la información o
            programas disponibles en o a través de esta página o en general
            cualquier falla en la misma.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            No obstante lo anterior, EL SEÑORON COMERCIAL podrá actualizar el
            contenido de la página constantemente, por lo que se solicita al
            Usuario tomar en cuenta que algunas informaciones publicitadas o
            contenidas en o a través de El señoron pueden haber quedado
            obsoletas y/o contener imprecisiones o errores tipográficos u
            ortográficos.
          </li>
        </ul>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          LIMITACIONES A LA RESPONSABILIDAD
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          En ningún caso EL SEÑORON COMERCIAL será responsable de algún daño,
          incluyendo enunciativa más no limitativamente: daños, pérdidas o
          gastos directos, indirectos, inherentes o consecuentes, que surjan en
          relación con esta aplicación o su uso o imposibilidad de uso por
          alguna de las partes, o en relación con cualquier falla en el
          rendimiento, error, omisión, interrupción, defecto, demora en la
          operación o transmisión, virus de computadora o falla de sistema o
          línea, aún en el caso de que EL SEÑORON COMERCIAL, o sus
          representantes fueran informados sobre la posibilidad de dichos daños,
          pérdidas o gastos.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL no tiene posibilidad de negar la venta cuando los
          datos del Usuario coincidan con nuestros registros. La clave de acceso
          y contraseña quedan completamente bajo responsabilidad del
          propietario. No se hará ninguna bonificación por compra fraudulenta.
        </p>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          INDEMNIZACIÓN
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          El Usuario está de acuerdo en indemnizar a EL SEÑORON COMERCIAL de
          cualquier acción, demanda o reclamación, incluso de honorarios de
          abogados y costos judiciales, derivadas de cualesquier incumplimiento
          por parte del Usuario a los presentes Términos y Condiciones,
          incluyendo sin limitación de alguna de las derivadas:
        </p>
        <ul className="text-lg list-disc px-4">
          <li className="list-disc mb-4 text-gray-700 leading-7">
            De cualquier aspecto relativo al uso de El señoron.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            De la información proporcionada a EL SEÑORON COMERCIAL para el uso
            de la aplicación y realización de pedidos.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            De injurias, difamación o cualquier conducta violatoria de los
            presentes Términos y Condiciones por parte del Usuario.
          </li>
          <li className="list-disc mb-4 text-gray-700 leading-7">
            De violación a las leyes aplicables o tratados internacionales.{" "}
          </li>
        </ul>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL se obliga a cumplir con sus compromisos y
          obligaciones asumidas según estos Términos y Condiciones, siempre y
          cuando el Usuario cumpla con todos los compromisos y obligaciones
          adquiridos y señalados en el presente documento, así como en la
          confirmación de pedido.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL podrá, en cualquier tiempo y cuando así lo estime
          conveniente, ceder total o parcialmente sus derechos y obligaciones
          derivados de los presentes Términos y Condiciones. En virtud de dicha
          cesión, EL SEÑORON COMERCIAL quedará liberado de cualquier obligación
          a favor del Usuario establecida en los presentes Términos y
          Condiciones.
        </p>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          Disposiciones generales
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          EL SEÑORON COMERCIAL se reserva el derecho, a su exclusiva discreción,
          y sin necesidad de aviso o notificación al Usuario para: (i) terminar
          definitivamente este convenio relativo a los Términos y Condiciones
          del uso de El señoron; y, (ii) descontinuar o dejar de publicar
          definitivamente la aplicación sin responsabilidad alguna.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los presentes Términos y Condiciones constituyen el acuerdo total
          entre las partes. Cualquier cláusula de los mismos, legalmente
          declarada inválida, será eliminada o modificada a elección de EL
          SEÑORON COMERCIAL, a fin de corregir su vicio o defecto y el resto de
          las cláusulas mantendrán su obligatoriedad y validez.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          La inactividad por parte de EL SEÑORON COMERCIAL al ejercicio de
          cualquier derecho o acción derivados de los presentes Términos y
          Condiciones, en ningún momento deberá interpretarse como renuncia a
          dichos derechos o acciones.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Los presentes Términos y Condiciones están sujetos y serán
          interpretados de acuerdo con la legislación aplicable vigente en la
          República Mexicana. Cualquier controversia que deba resolverse en
          virtud del uso de El señoron y/o los servicios que deriven de la
          misma, las partes acuerdan someterse a la jurisdicción de los
          Tribunales de la Ciudad de Monterrey, Nuevo León, renunciando a
          cualquier otra jurisdicción que pudiese corresponderle por su
          domicilio presente o futuro, o por cualquier otra causa.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Mediante la utilización de El señoron el Usuario acepta que las
          comunicaciones que se le efectúen serán principalmente electrónicas,
          pudiendo EL SEÑORON COMERCIAL: (i) contactarlo vía correo electrónico;
          (ii) enviarle notificaciones mediante la aplicación El señoron; (iii)
          contactarlo vía mensaje de texto (SMS); o bien; (iv) publicando la
          información correspondiente en la aplicación.
        </p>
        <p className="mb-4 text-lg text-gray-900 font-bold leading-7">
          DATOS DE CONTACTO
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Toda consulta, queja, sugerencia o comentario relativo a los presentes
          Términos y Condiciones deberá dirigirse a:
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Call Center El señoron: (81)14952291.
        </p>
        <p className="mb-4 text-lg text-gray-700 leading-7">
          Correo electrónico:{" "}
          <a href="mailto:senoron.atencionclientes@gmail.com" className="font-medium text-gray-900">
            senoron.atencionclientes@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
